import { themeColorCss } from '@sites/site-theme/src/utils/variables';
import { rotateVar } from '@sites/entity-core';

/**
 * CSS custom properties for the accordion widget — the LESS twin of the former JSS `getStyles`.
 * ONE module shared by both apps; the static rules consuming the variables live in
 * `accordion.base.less` (`@sites/entity-core/src/widget/accordion/styles/`).
 *
 * The smallest settings surface of any migrated widget: no shadow, no per-item styling, no
 * animation. Root rotate/z-index (per device, video/button pattern), a divider colour (gated by
 * the `accordion-indent` modifier class rather than a `none`-valued var — an unset border shorthand
 * would be invalid at computed-value time), and an icon colour. Icon SHAPE (Plus vs Caret) and
 * layout side (left vs right, which also carries the margin swap) stay modifier classes — full
 * shape/margin changes, not single-property tweaks.
 */

export function accordionTransformCss(rotate: number | null | undefined): string {
    return rotateVar(rotate);
}

/**
 * Same value feeds BOTH the mobile and tablet CSS variables — the entity's `position` grid has no
 * tablet-specific field at all, mirroring the legacy JSS this replaces (its tablet constructor
 * selector also read `mobileRotate`).
 */
export function accordionTransformMobileCss(mobileRotate: number | null | undefined): string {
    return rotateVar(mobileRotate);
}

export function accordionZIndexCss(zIndex: number | null | undefined): string | null {
    return zIndex != null ? `${zIndex}` : null;
}

/** Same `isSynchronizeStyle ? zIndex : mobileZIndex` value feeds both mobile and tablet vars. */
export function accordionZIndexMobileCss(
    isSynchronizeStyle: boolean | null | undefined,
    zIndex: number | null | undefined,
    mobileZIndex: number | null | undefined
): string | null {
    const value = isSynchronizeStyle ? zIndex : mobileZIndex;
    return value != null ? `${value}` : null;
}

export function accordionDividerColorCss(themeColor: string | null | undefined, color: string): string {
    return themeColor ? themeColorCss(themeColor) : color;
}

export function accordionIconColorCss(themeColor: string | null | undefined, color: string): string {
    return themeColor ? themeColorCss(themeColor) : color;
}
